import './modernizr-custom'
import $ from 'jquery'


// Load Jquery UI Range Slider
import 'jquery-ui/ui/widgets/slider';

import Swiper, {Navigation, Pagination} from 'swiper';
import 'swiper/css';

Swiper.use([Navigation, Pagination]);

// Load Bootstrap JS
import popperjs from '@popperjs/core'
import bootstrap from 'bootstrap'

require('fslightbox')
import 'slick-carousel'


// Load Styles
import '../scss/main.scss'

$(document).ready(function () {
  dinamicBodyPaddingMargin()
  columnsReset()
  scrolledMainNavigationHide()
  navDropDownOnHover()
  toggleNavIcon()
  togglePlayerButton()
})


$(window).resize(function () {
  dinamicBodyPaddingMargin()
  columnsReset()
  scrolledMainNavigationHide()

  if ($(window).width() > 992) {
    $('#lang-switch ion-icon').removeClass('text-white');
    navDropDownOnHover()
  }
})

let footerHeight = $('footer').outerHeight();
let navHeight = $('nav').outerHeight();

// Custom Functions
function dinamicBodyPaddingMargin() {
  $('body').css({
    //'paddingBottom': footerHeight,
    //'marginBottom': footerHeight,
    //'paddingTop': navHeight
  })
  if ($(window).width() < 1536) {
    $('body').css({
      'paddingTop': navHeight / 3
    })
  }
}


function columnsReset() {
  let possibleColumnList = [2, 3, 4];
  $.each(possibleColumnList, function () {

    let elCssInlineColumn2 = $('.column-content-2');
    let elCssInlineColumn3 = $('.column-content-3');
    let elCssInlineColumn4 = $('.column-content-4');

    if ($(window).width() < 992) {
      elCssInlineColumn2.css("column-count", 1)
      elCssInlineColumn3.css("column-count", 1)
      elCssInlineColumn4.css("column-count", 1)
    }

    if ($(window).width() > 992) {
      elCssInlineColumn2.css("column-count", 2)
      elCssInlineColumn3.css("column-count", 3)
      elCssInlineColumn4.css("column-count", 4)
    }
  })
}

// remove empty section elements
let elements = document.getElementsByTagName("section");

for (let i = 0; i < elements.length; i++) {
  if (elements[i].textContent.trim() === '')
    elements[i].parentNode.removeChild(elements[i]);
}


let langswitchEl = $('#lang-switch');
let langswitchBlockEl = $('#lang-block');

let searchEl = $('#navi-search');
let searchBlockEl = $('#search-block');
let closeInfoBlock = $('.close-banner');

langswitchEl.on('click', function (e) {
  e.preventDefault();
  langswitchBlockEl.slideToggle("slow");
})

searchEl.on('click', function (e) {
  e.preventDefault();
  searchBlockEl.slideToggle("slow");
})

closeInfoBlock.on('click', function () {
  searchBlockEl.fadeOut("slow");
  langswitchBlockEl.fadeOut("slow");
})

function scrolledMainNavigationHide() {
  let pxTrigger = 0;
  let pinned = true;

  $(window).scroll(function () {
    let scrollPosition = window.scrollY || window.pageYOffset;

    if ($(window).width() > 992) {
      if (scrollPosition > navHeight) {
        $('nav').removeClass('nav--pinned');
        if ($(window).width() < 1536) {
          $('.siek-addtional-navbar').css('position', 'static');
        }
        pinned = scrollPosition < pxTrigger;
        pxTrigger = scrollPosition;
      }
      if (pinned === true) {
        $('nav').addClass('nav--pinned');
        if ($(window).width() < 1536) {
          $('.siek-addtional-navbar').css('position', 'fixed');
        }

      }
    }
    if ($(window).width() < 992) {
      $('nav').addClass('nav--pinned')
    }
  })

}


function togglePlayerButton() {
  let playercoverbutton = $('.player-cover');

  playercoverbutton.on('click', function () {
    $(this).toggleClass('remove-player-cover');
  })
}


function toggleNavIcon() {
  let buttonBurger = $('button.navbar-toggler');
  let toggled = false;
  buttonBurger.click(function () {
    // toggled = !toggled;
    $(this).toggleClass('close-outline');
    // iconDomEl.attr("name", toggled ? closeIcon : burgerIcon);
  });
}


$('#history-timeline').slick({
  slidesToShow: 1,
  arrows: true,
  slidesToScroll: 1,
  fade: false,
  infinite: true,
  useTransform: true,
  speed: 400,
  cssEase: 'cubic-bezier(0.77, 0, 0.18, 1)',
  responsive: [{
    breakpoint: 1024,
    settings: {
      dots: true,
      arrows: false,
      slidesToShow: 1,
    }
  }]
})


$(document).ready(function ($) {
  let years = document.querySelectorAll('.year-content');
  let myswiper = new Swiper("#timelineSwiper", {
    pagination: {
      el: ".timelineswiper-pagination",
      clickable: true,
      renderBullet: function (index, className) {
        let eleYear = years[index].innerHTML;
        return '<span class="' + className + '"><span>' + eleYear + "</span></span>";
      },
    },
    navigation: {
      nextEl: ".timeline-swiper-button-next",
      prevEl: ".timeline-swiper-button-prev",
    },
  });
});


function navDropDownOnHover() {

  document.querySelectorAll('.navbar .nav-item').forEach(function (everyitem) {

    if ($(window).width() > 992) {
      everyitem.addEventListener('mouseover', function (e) {

        let el_link = this.querySelector('a[data-bs-toggle]');
        if (el_link != null) {
          let nextEl = el_link.nextElementSibling;
          el_link.classList.add('show');
          nextEl.classList.add('show');
        }

      });

      everyitem.addEventListener('mouseleave', function (e) {

        let el_link = this.querySelector('a[data-bs-toggle]');

        if (el_link != null) {
          let nextEl = el_link.nextElementSibling;
          el_link.classList.remove('show');
          nextEl.classList.remove('show');
        }

      })
    }


  });


}


$(document).ready(function ($) {
  let sieker_filter = "", sieker_kw_min = false, sieker_kw_max = false;
  if ("sieker_filter" in sessionStorage) {
    sieker_filter = sessionStorage.sieker_filter;
  }



  var steps = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 15, 20, 50, 100, 150, 500];
  $("#slider-leistung").slider({
    range: true,
    min: 0,
    max: 15,
    values: [0, 15],
    step: 1,
    create: function () {
      $('#lmin').appendTo($('#slider-leistung .ui-slider-handle').get(0));
      $('#lmax').appendTo($('#slider-leistung .ui-slider-handle').get(1));
    },
    slide: function (event, ui) {
      $(ui.handle).find('.lmvalue').html(steps[ui.value]);
      $('#leistung-min').text(steps[ui.values[0]]);
      $('#leistung-max').text(steps[ui.values[1]]);
      $('#leistung-min-index').text(ui.values[0]);
      $('#leistung-max-index').text(ui.values[1]);
    },
    change: function (event, ui) {
      $(ui.handle).find('.lmvalue').html(steps[ui.value]);
      $('#leistung-min').text(steps[ui.values[0]]);
      $('#leistung-max').text(steps[ui.values[1]]);
      $('#leistung-min-index').text(ui.values[0]);
      $('#leistung-max-index').text(ui.values[1]);
    },
  });


  $('#filter-anwenden').click(function () {
    let anschlussWerte=[];
    let anschlussCheckboxes = $(".filter-anschluss input:checked");
      anschlussCheckboxes.each(function () {
        anschlussWerte.push($(this).val());
      });

    const minwert = parseFloat($('#leistung-min').text());
    const maxwert = parseFloat($('#leistung-max').text());
    const minwert_index = parseFloat($('#leistung-min-index').text());
    const maxwert_index = parseFloat($('#leistung-max-index').text());
    $('.products .product').each(function (index) {
      let singleLeistung = parseFloat($(this).data('leistung').substring(3).replace("-", "."));

      //  console.log($(this).data('anschluss'), anschlussWerte.includes($(this).data('anschluss')));
      if (anschlussWerte.length > 0) {
        // wenn nur durchlaufrohr ausgewählt wird, ignoiere leistung filter
        /*if (anschlussWerte.length == 1 && anschlussWerte[0] == 'durchlaufrohr' && $(this).data('anschluss') == 'durchlaufrohr') {
          $(this).removeClass('filter-hidden');
        }else */
        if (anschlussWerte.includes($(this).data('anschluss')) && $(this).data('anschluss') == 'zubehoer') {
          $(this).removeClass('filter-hidden');
        }else if (anschlussWerte.includes($(this).data('anschluss')) && $(this).data('anschluss') == 'accessory') {
          $(this).removeClass('filter-hidden');
        }
        else if (singleLeistung >= minwert && singleLeistung <= maxwert && anschlussWerte.includes($(this).data('anschluss'))) {
          $(this).removeClass('filter-hidden');
        } else {
          $(this).addClass('filter-hidden');
        }
      } else {
        if (singleLeistung >= minwert && singleLeistung <= maxwert) {
          $(this).removeClass('filter-hidden');
        } else {
          $(this).addClass('filter-hidden');
        }
      }
    });
    window.sessionStorage.setItem('sieker_filter', anschlussWerte.join(','));
    window.sessionStorage.setItem('sieker_kw_min', minwert_index);
    window.sessionStorage.setItem('sieker_kw_max', maxwert_index);
  });
  let filterAction =false;
  if ("sieker_kw_max" in sessionStorage && "sieker_kw_min" in sessionStorage) {
    sieker_kw_max = sessionStorage.sieker_kw_max;
    sieker_kw_min = sessionStorage.sieker_kw_min;
    $("#slider-leistung").slider("values", [sieker_kw_min, sieker_kw_max]);
    filterAction=true;
  }
  if ("sieker_filter" in sessionStorage){
    let anschlussWerteSession = [];
    sieker_filter = sessionStorage.sieker_filter;
    anschlussWerteSession = sieker_filter.split(',');
    if(anschlussWerteSession.length>0){
      $.each(anschlussWerteSession,function(index, value){
        $("#"+value).prop('checked', true);
      });
      filterAction=true;
    }
  }
  if(filterAction){
    $('#filter-anwenden').click();
  }

});

$('#fachbegriffe a').each(function () {
  $(this).on('click', function () {
    $('#fachbegriffe a').removeClass('act');
    $(this).addClass('act');
  })
});

// Demo of using .env variables
// console.log(`Google Maps API Key: ${process.env.GOOGLE_MAPS_API_KEY}`);
